import SwatchFilters from '../components/swatch-filters';

document.addEventListener('DOMContentLoaded', function (e) {
  window.defer(function () {
    new SwatchFilters('.ProductForm__Option');
  }, '.ProductForm__Option label.ColorSwatch');

  window.defer(() => {
    new SwatchFilters('.shade-selector-modal__wrapper');
  }, '.shade-selector-modal__wrapper');
});
